import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.toast');
import { ChangeDetectorRef } from '@angular/core';
import { ToastService } from 'src/app/shared/toast.service';

@Component({
    selector: 'wiz-component-toast',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.toast/view.scss */
:host {
  display: contents;
}

.toast-stack {
  display: grid;
  gap: 10px;
  position: fixed;
  right: 18px;
  bottom: 18px;
  z-index: 1000;
  width: min(360px, 100vw - 36px);
  pointer-events: none;
}

.global-toast {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  padding: 10px 12px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 750;
  line-height: 1.35;
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.24);
  pointer-events: auto;
}

.global-toast.success {
  background: #15803d;
}

.global-toast.error {
  background: #dc2626;
}

.global-toast.info {
  background: #5c5caa;
}

.global-toast span {
  flex: 1 1 auto;
  min-width: 0;
}

.global-toast button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  color: inherit;
  cursor: pointer;
}

@media (max-width: 520px) {
  .toast-stack {
    right: 12px;
    bottom: 12px;
    width: calc(100vw - 24px);
  }
}`],
})
export class ComponentToastComponent {
    constructor(@Inject( ToastService) public toast: ToastService,@Inject( ChangeDetectorRef)  public ref: ChangeDetectorRef) { }

    public dismiss(id: number) {
        this.toast.dismiss(id);
        try {
            this.ref.detectChanges();
        } catch { }
    }
}

export default ComponentToastComponent;